// src/context/AuthContext.js

import React, { createContext, useContext, useState, useEffect, useRef } from 'react';
import { decodeJWT } from '../utils/functions';


// Contexto para armazenar o estado de autenticação
const AuthContext = createContext();

export const useAuth = () => useContext(AuthContext);

export const AuthProvider = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [loading, setLoading] = useState(true);
  const [user, setUser] = useState(null);
  const [permissions, setPermissions] = useState([]);
  const logoutTimerRef = useRef(null);

  const clearLogoutTimer = () => {
    if (logoutTimerRef.current) {
      clearTimeout(logoutTimerRef.current);
      logoutTimerRef.current = null;
    }
  };

  const scheduleAutoLogout = (expSeconds) => {
    clearLogoutTimer();
    if (!expSeconds) return;
    const nowSeconds = Math.floor(Date.now() / 1000);
    const secondsToExpiry = expSeconds - nowSeconds;
    if (secondsToExpiry <= 0) {
      logout();
      return;
    }
    logoutTimerRef.current = setTimeout(() => {
      logout();
    }, secondsToExpiry * 1000);
  };

  useEffect(() => {
    const token = localStorage.getItem('authToken');
    if (token) {
      const decodedUser = decodeJWT(token);
      const exp = decodedUser?.exp;
      if (!decodedUser || (exp && exp * 1000 <= Date.now())) {
        logout();
      } else {
        setUser(decodedUser);
        setPermissions(decodedUser.permissoes || []);
        setIsAuthenticated(true);
        if (exp) scheduleAutoLogout(exp);
      }
    }
    setLoading(false);
  }, []);



  const login = (token, user, permissions) => {
    localStorage.setItem('authToken', token);
    localStorage.setItem('username', user.username);

    // Primeiro define o estado de autenticação
    setIsAuthenticated(true);

    // Depois decodifica o token para dados mais confiáveis
    const decoded = decodeJWT(token);
    setUser(decoded || user);
    setPermissions((decoded && decoded.permissoes) || permissions || []);

    // Por último, agenda o auto-logout
    if (decoded?.exp) scheduleAutoLogout(decoded.exp);
  };

  const logout = () => {
    localStorage.removeItem('authToken');
    setIsAuthenticated(false);
    setUser(null);
    setPermissions([]);
    clearLogoutTimer();
  };

  return (
    <AuthContext.Provider value={{ isAuthenticated, user, permissions, login, logout, loading }}>
      {children}
    </AuthContext.Provider>
  );
};